import { connect } from 'react-redux';
import RegionAssignment from './RegionAssignment';
import { getStates, getCountiesByState, assignAppraiserManagerToStates, assignAppraiserManagerToCounties } from 'actions/region';
import * as employeeRoles from 'typeConstants/employeeRoles';

const mapStateToProps = (state) => {
  return {
    states: state.region.states,
    counties: state.region.countiesByState,
    isFetchingStates: state.region.isFetchingStates,
    isFetchingCounties: state.region.isFetchingCountiesByState,
    cardTitle: "Assign Appraiser Manager Region",
    employeeRoles: [employeeRoles.VALUATION_QUALITY_ASSOCIATE, employeeRoles.VALUATION_DIRECTOR]
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStates() {
    dispatch(getStates());
  },
  getCountiesByState(states) {
    dispatch(getCountiesByState(states));
  },
  assignStates(request) {
    dispatch(assignAppraiserManagerToStates(request));
  },
  assignCounties(request) {
    dispatch(assignAppraiserManagerToCounties(request));
  },
});


export default connect(mapStateToProps, mapDispatchToProps)(RegionAssignment);